import { type PropsWithChildren, useRef } from 'react';

import { type Store, createStore } from '../../../../core/store/store.js';
import type {
  CustomColorPalette,
  ColorPalette,
} from '../../../core/types/color-palette.js';
import { INITIAL_STATE } from '../constants.js';
import { MultiMeterBarChartStore } from '../context/MultiMeterBarChartStore.js';
import { useMultiMeterBarStore } from '../hooks/useMultiMeterBarStore.js';
import type { MultiMeterBarSegmentProps } from '../types/multi-meter-bar-chart.js';
import type { MultiMeterBarChartState } from '../types/state.js';

export interface StoreProviderProps {
  colorPalette: ColorPalette | CustomColorPalette;
  segmentsSlot: MultiMeterBarSegmentProps[];
}

export const StoreProvider = ({
  colorPalette,
  segmentsSlot,
  children,
}: PropsWithChildren<StoreProviderProps>) => {
  const storeRef = useRef<Store<MultiMeterBarChartState> | null>(null);

  const { initSegmentsState } = useMultiMeterBarStore();

  const { segments, visibleSegments } = initSegmentsState(
    segmentsSlot,
    colorPalette,
  );

  storeRef.current = createStore({
    ...INITIAL_STATE,
    segments,
    visibleSegments,
  });

  return (
    <MultiMeterBarChartStore.Provider value={storeRef.current}>
      {children}
    </MultiMeterBarChartStore.Provider>
  );
};
